'use client';

import { isTMA } from '@telegram-apps/bridge';
import { useEffect, useState } from 'react';

export const IsTelegram = () => {
  const [isTelegram, setIsTelegram] = useState(false);

  useEffect(() => {
    isTMA('complete').then((value) => {
      setIsTelegram(value);
    });
  }, []);

  return isTelegram;
};
